export default __webpack_public_path__ + "static/media/Location ID.352af238.svg";